import { render } from "./ManageMessages.vue?vue&type=template&id=6a35dca1"
import script from "./ManageMessages.vue?vue&type=script&lang=js"
export * from "./ManageMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__